/**
 * Debug helpers for diagnosing issues
 */

export function clearAllLocalStorage() {
  localStorage.clear();
  console.log('✅ All localStorage cleared');
  window.location.reload();
}

export function inspectJourneyData() {
  const journeyData = localStorage.getItem('peak_priorities_user_journey');
  if (journeyData) {
    try {
      const parsed = JSON.parse(journeyData);
      console.log('📊 Journey Data:', parsed);
      return parsed;
    } catch (error) {
      console.error('❌ Journey data is corrupted:', error);
      return null;
    }
  } else {
    console.log('ℹ️ No journey data found in localStorage');
    return null;
  }
}

export function resetProgressWidget() {
  localStorage.removeItem('peak_priorities_user_journey');
  console.log('✅ Journey data cleared');
  window.location.reload();
}

// Make available in console
if (typeof window !== 'undefined') {
  (window as any).debugHelpers = {
    clearAllLocalStorage,
    inspectJourneyData,
    resetProgressWidget,
  };
  console.log('🔧 Debug helpers loaded! Use:');
  console.log('  - debugHelpers.clearAllLocalStorage()');
  console.log('  - debugHelpers.inspectJourneyData()');
  console.log('  - debugHelpers.resetProgressWidget()');
}

